import { RightCircleOutlined } from "@ant-design/icons";
import { Col, /*Rate,*/ Row, Tabs } from "antd";
import _ from "lodash";
import React, { createRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next/";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import { selectSections } from "../../redux/reducers/slice/home";
import { sections } from "../../services";
import { setTitlePage } from "../../utils/helper";
import {
  AREA_STORES,
  SECTION_STORE,
  STORE_AGENCY_LINK,
  WIDTH_IPAD,
} from "./../../common/constant";
import NearbyStores from "./nearbyStrores";
import "./style.scss";

const StoreAgency = () => {
  const { t } = useTranslation();
  const sectionsData = useSelector(selectSections);
  const sectionId = SECTION_STORE;
  const [sliders, setSliders] = useState<any>([]);
  const [stores, setStores] = useState<any>(
    (sectionsData &&
      sectionsData.length &&
      sectionsData.filter((s: any) => s._id.toString() === sectionId[0])) ||
      []
  );
  const { innerWidth } = window;

  useEffect(() => {
    setTitlePage(t("title_page_store_agency"));

    if (!stores.length) {
      sections.getSections({ ids: sectionId }, (data: any, err: any) => {
        if (data && data.data && data.data.length) {
          setStores(data.data);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (stores.length) {
      setSliders(() => stores[0].children.map((_: any) => createRef()));
    }
  }, [stores]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
  };

  const showSlide = (data: any) =>
    data.map((d: any, i: number) => (
      <img key={i} src={d.path} alt="" style={{ width: "100%" }} />
    ));

  const renderTabBar = (props: any, DefaultTabBar: React.ComponentType<{}>) => (
    <div className="area-tabs">
      <DefaultTabBar {...props} />
    </div>
  );

  const showAreaStores = (data: any) =>
    data.map((d: any) => {
      const _stores = _.sortBy(
        stores[0].children.filter(
          (item: any) =>
            !item.is_children_future &&
            (d.key === item.area_store || d.key === "ALL")
        ),
        ["order"]
      );
      return _stores.length ? (
        <Tabs.TabPane
          tab={
            <span className="main-content stores-tab-name">
              <div className="tab-icon"></div>
              {t(d.name)}
            </span>
          }
          key={d.key}>
          {showStoreItem(_stores)}
        </Tabs.TabPane>
      ) : null;
    });

  const showStoreItem = (data: any) =>
    data.map((d: any, i: number) => (
      <Col key={i} span={24} style={{ marginBottom: 20 }}>
        <Row>
          <Col xs={24} md={2} className="reviews-wrap">
            {/* <div className="reviews-item">
        <span>reviews</span>
        <Rate className="stars-review" disabled defaultValue={4} />
      </div> */}
          </Col>
          <Col
            xs={24}
            md={22}
            style={{ backgroundColor: "rgba(225,225,225,0.2)" }}>
            <Row align="middle" wrap>
              <Col xs={24} md={10} className="store-item-wrap">
                <Row justify="center" className="address-title">
                  <span className="main-title">{d.title}</span>
                </Row>
                <Row justify="center" className="address-item sub-title">
                  {d.sub_title}
                </Row>
                <Row
                  justify="center"
                  className="sub-title"
                  style={{ marginBottom: 20, textAlign: "center" }}>
                  {d.is_children_future ? "" : d.content}
                </Row>
                <Row justify="center">
                  <a
                    href={d.url}
                    target={d.target}
                    className="kd-btn-primary-2 btn-go-to-map">
                    {d.is_children_future ? d.content : "Chỉ đường"}
                  </a>
                </Row>
              </Col>
              <Col xs={24} md={14}>
                <Slider {...settings} ref={(c) => (sliders[i] = c)}>
                  {showSlide(
                    (d.sub_images.length &&
                      d.sub_images[0].galaries.length &&
                      d.sub_images[0].galaries) ||
                      []
                  )}
                </Slider>
                {d.sub_images.length && d.sub_images[0].galaries.length > 1 ? (
                  <a
                    className="store-arrow-right"
                    onClick={() => sliders[i].slickNext()}>
                    <RightCircleOutlined
                      style={{
                        fontSize: "2rem",
                        color: "rgba(225,225,225, 0.6)",
                      }}
                    />
                  </a>
                ) : null}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    ));

  return (
    (stores.length && (
      <div className="store-agency-container">
        <div>
          <img
            src={
              (stores[0].images.length &&
                stores[0].images[0].galaries.length &&
                stores[0].images[0].galaries[0].path) ||
              ""
            }
            alt=""
            style={{ width: "100%" }}
          />
        </div>
        {stores[0].sub_title ? (
          <div className="store-agency-description-wrap">
            <p className="sub-title">
              <div
                dangerouslySetInnerHTML={{
                  __html: stores[0].sub_title,
                }}></div>
            </p>
          </div>
        ) : null}
        <div style={{ width: "100%" }}>
          <Row justify="center" className="store-agency-title">
            <span className="large-title">Hệ thống cửa hàng trải nghiệm</span>
          </Row>

          <Tabs
            renderTabBar={renderTabBar}
            tabBarStyle={{
              marginLeft: innerWidth > WIDTH_IPAD ? "8.33%" : "2%",
            }}>
            {showAreaStores(_.sortBy(AREA_STORES, ["order"]))}
            <Tabs.TabPane
              tab={
                <span className="main-content stores-tab-name">
                  <div className="tab-icon find-store-icon"></div>
                  Tìm kiếm cửa hàng gần nhất
                </span>
              }
              key={AREA_STORES.length}>
              <NearbyStores />
            </Tabs.TabPane>
          </Tabs>

          <Row justify="center" style={{ padding: "0 8%" }}>
            <span className="sub-title">
              Để xem danh sách đầy đủ các Cửa hàng và Đại lý Kymdan chính hãng
              trên toàn quốc, Xin vui lòng truy cập tại:{" "}
              <a
                href={STORE_AGENCY_LINK}
                target="_blank"
                className="store-link">
                {STORE_AGENCY_LINK}
              </a>
              .
            </span>
          </Row>
        </div>
        {!!stores[0].children.filter((i: any) => i.is_children_future)
          .length && (
          <div style={{ width: "100%" }}>
            <Row justify="center" className="store-agency-title">
              <span className="large-title">coming soon</span>
            </Row>
            {showStoreItem(
              _.sortBy(
                stores[0].children.filter(
                  (item: any) => item.is_children_future
                ),
                ["order"]
              )
            )}
          </div>
        )}
      </div>
    )) || <></>
  );
};

export default StoreAgency;
